import React, { useMemo } from 'react';
import { ResponsiveImageModel } from '../../Types/ResponsiveImageModel'
import { breakpointValues } from '../../styling/variables/grid'
import { ImageUrlSizeDefinition } from '../../Types/ResponsiveImageModel';

const ResponsiveImage = ({
  sizeDefinitions,
  alt,
  lazyLoad = false,
  grow = false,
  pictureClassName,
  imgClassName,
}: ResponsiveImageModel) => {
  const smallestImage = useMemo(
    () => sizeDefinitions?.slice().sort((a, b) => a.width - b.width)[0],
    [sizeDefinitions]
  );

  const orderedSizeDefinitions = useMemo(
    () =>
      sizeDefinitions?.slice().sort((a, b) => b.fromWidth - a.fromWidth),
    [sizeDefinitions]
  );

  const getMinWidth = (sizeDefinition: ImageUrlSizeDefinition) => {
    if(sizeDefinition.fromWidth)
      return sizeDefinition.fromWidth

    if(sizeDefinition.fromBreakpoint)
      return breakpointValues[sizeDefinition.fromBreakpoint]
  }

  return (
    <picture className={pictureClassName}>
      {orderedSizeDefinitions &&
        orderedSizeDefinitions.length > 1 &&
        orderedSizeDefinitions.map((img, idx) => (
          <source
            key={img.url + idx + 'source'}
            srcSet={img.url}
            media={`(min-width: ${getMinWidth(img)}px)`}
          />
        ))}
      {grow == false ? (
        <img
          src={smallestImage?.url}
          loading={lazyLoad ? 'lazy' : undefined}
          alt={alt}
          width={
            grow == false && !!smallestImage?.width
              ? smallestImage?.width
              : undefined
          }
          height={
            grow == false && !!smallestImage?.height
              ? smallestImage?.height
              : undefined
          }
          className={imgClassName}
        />
      ) : (
        <img
          src={smallestImage?.url}
          loading={lazyLoad ? 'lazy' : undefined}
          alt={alt}
          className={imgClassName}
        />
      )}
    </picture>
  );
};

export default ResponsiveImage;
